import { ElementProps } from '@/components/sections/builder/types';
import { ScrollingTextElementDataType } from '@/components/sections/builder/elements/body/scrolling-text/types';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import { Checkbox } from '@/components/ui/checkbox';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as ScrollingTextElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Setting</div>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='separator'
          className='mx-2'
          checked={data.separator}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              separator: !!checked,
            });
          }}
        />
        <label htmlFor='separator'>Show separator line</label>
      </div>
      <div className='mb-2 mt-4 font-bold'>Duration</div>
      <div className='flex items-center'>
        <div className='w-full'>
          <InputSlider
            value={data.duration || 0}
            onChange={(val) => {
              builder.setElementData(element.id, {
                duration: val,
              });
            }}
          />
        </div>
      </div>
      <div className='mb-4 mt-4 font-bold'>Direction</div>
      <InputTab
        grid={2}
        defaultValue={data.direction}
        options={[
          { label: 'To Left', value: 'left' },
          { label: 'To Right', value: 'right' },
        ]}
        onChange={(v) =>
          builder.setElementData(element.id, {
            direction: v,
          })
        }
      />
      <div className='mb-4 mt-4 font-bold'>Text Size</div>
      <InputTab
        defaultValue={data.fontSize}
        options={[
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' },
        ]}
        onChange={(v) =>
          builder.setElementData(element.id, {
            fontSize: v,
          })
        }
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={data.colorSchemeScrollingText}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorSchemeScrollingText: theme,
          });
        }}
      />
      <PaddingSetting
        value={data.padding}
        onChange={(v) =>
          builder.setElementData(element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}
